"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_STYLES = exports.getThemeContext = exports.createTheme = exports.withVariants = exports.createColor = void 0;
const css_1 = require("@emotion/css");
const utils_1 = require("@obvio/utils");
const collections_1 = require("@obvio/utils/collections");
const colors_1 = require("@obvio/utils/colors");
const defaultContexts_1 = require("./defaultContexts");
const styled_1 = require("./styled");
var colors_2 = require("@obvio/utils/colors");
Object.defineProperty(exports, "createColor", { enumerable: true, get: function () { return colors_2.createColor; } });
function withVariants(css, variants) {
    return Object.assign(Object.assign({}, variants), { css });
}
exports.withVariants = withVariants;
const DEFAULT_PRIMARY = '#3c84c4';
const DEFAULT_ERROR = '#cd2030';
const DEFAULT_WARNING = '#ff9800';
const DEFAULT_SUCCESS = '#4caf50';
const DEFAULT_SPACING = {
    extraSmall: '0.75rem',
    small: '1rem',
    medium: '1.5rem',
    big: '2rem',
    large: '3rem',
    extraLarge: '5rem',
};
const DEFAULT_RADIUS = { small: '0.625rem', big: '1.625rem' };
const DEFAULT_MODAL = {};
const DEFAULT_DROPDOWN = {};
const DEFAULT_TOOLTIP = {};
const DEFAULT_SHADOWS = {
    small: '0 0.25rem 1.75rem rgba(0, 0, 0, 0.15)',
    medium: '0 0.5rem 2rem rgba(0, 0, 0, 0.2)',
    big: '0 0.75rem 2.5rem rgba(0, 0, 0, 0.2)',
};
const DEFAULT_PAGE = {
    width: '75rem',
    center: true,
    margin: { notMobile: '3.75rem', mobile: '2.5rem', tinyMobile: '1.25rem' },
    sectionSpacing: { desktop: '7.5rem', notDesktop: '5rem' },
};
function createTheme(customTheme = {}) {
    var _a, _b, _c, _d, _e, _f;
    const colors = createColorPalette(customTheme.colors);
    const theme = customTheme;
    const customContexts = Object.assign(Object.assign({}, customTheme.context), { checkout: Object.assign(Object.assign({}, defaultContexts_1.CHECKOUT_CONTEXT), (_a = customTheme.context) === null || _a === void 0 ? void 0 : _a.checkout), TEMPLATE_underConstruction: Object.assign(Object.assign({}, defaultContexts_1.TEMPLATE_UNDERCONSTRUCTION_CONTEXT), (_b = customTheme.context) === null || _b === void 0 ? void 0 : _b.TEMPLATE_underConstruction) });
    theme.context = 'default';
    if (arguments[1] !== true) {
        addDefaultStyles(theme);
    }
    theme.colors = colors;
    Object.assign(theme, getThemeColors(customTheme, colors));
    theme.spacing = Object.assign(Object.assign({}, DEFAULT_SPACING), customTheme.spacing);
    theme.radius = Object.assign(Object.assign({}, DEFAULT_RADIUS), customTheme.radius);
    theme.modal = Object.assign(Object.assign({}, DEFAULT_MODAL), customTheme.modal);
    theme.dropdown = Object.assign(Object.assign({}, DEFAULT_DROPDOWN), customTheme.dropdown);
    theme.tooltip = Object.assign(Object.assign({}, DEFAULT_TOOLTIP), customTheme.tooltip);
    theme.shadows = Object.assign(Object.assign({}, DEFAULT_SHADOWS), customTheme.shadows);
    theme.page = Object.assign(Object.assign({}, DEFAULT_PAGE), customTheme.page);
    theme.pageWidth = ({ page: { width, margin, center } }) => (0, styled_1.css) `
    ${[
        (0, styled_1.css)(Object.assign(center ? { margin: '0 auto' } : {}, { width })),
        ...Object.keys(margin).map((m) => styled_1.styled[m]({
            maxWidth: `calc(100% - ${(0, utils_1.multiplyCssValue)(2, margin[m])})`,
        })),
    ]}
  `;
    theme.buttons = getButtonStyles(theme, customTheme.buttons);
    theme.inputs = (_c = customTheme.inputs) !== null && _c !== void 0 ? _c : {};
    theme.typography = getTypographyStyles(theme, customTheme.typography);
    theme.secondaryFont =
        (_e = (_d = customTheme.secondaryFont) !== null && _d !== void 0 ? _d : customTheme.font) !== null && _e !== void 0 ? _e : 'inherit';
    theme.links = (_f = customTheme.links) !== null && _f !== void 0 ? _f : {};
    (0, utils_1.set)(theme, '_context', [...new Set([...(0, collections_1.keys)(theme.colors), ...(0, collections_1.keys)(customContexts !== null && customContexts !== void 0 ? customContexts : {})])].reduce((all, ctx) => {
        var _a;
        if (ctx === 'additional') {
            theme.colors.additional.forEach((_, i) => {
                var _a, _b;
                const name = `${ctx}.${i}`;
                (0, utils_1.set)(all, name, (_b = (_a = customContexts === null || customContexts === void 0 ? void 0 : customContexts.additional) === null || _a === void 0 ? void 0 : _a[i]) !== null && _b !== void 0 ? _b : {});
            });
        }
        else {
            (0, utils_1.set)(all, ctx, (_a = customContexts === null || customContexts === void 0 ? void 0 : customContexts[ctx]) !== null && _a !== void 0 ? _a : {});
        }
        return all;
    }, { default: theme }));
    return theme;
}
exports.createTheme = createTheme;
function convertToColor(c) {
    return (0, colors_1.isColor)(c)
        ? c
        : Array.isArray(c)
            ? (0, colors_1.createColor)(c[0] || 'gray')
            : (0, colors_1.createColor)(c);
}
function createColorPalette(_a = {}) {
    var { additional = [] } = _a, colors = __rest(_a, ["additional"]);
    const shadeColors = (0, collections_1.map)(convertToColor, (0, collections_1.trueValues)(colors));
    const { primary, complementary, secondary, gray, error, warning, success } = shadeColors, other = __rest(shadeColors, ["primary", "complementary", "secondary", "gray", "error", "warning", "success"]);
    const resolvedPrimary = primary ||
        (0, colors_1.createColor)((complementary && (0, colors_1.getComplementaryColor)(complementary)) ||
            (secondary && (0, colors_1.getSecondaryColor)(secondary)) ||
            DEFAULT_PRIMARY);
    return Object.assign({ primary: resolvedPrimary, complementary: complementary || (0, colors_1.getComplementaryColor)(resolvedPrimary), secondary: secondary || (0, colors_1.getSecondaryColor)(resolvedPrimary), gray: gray || (0, colors_1.getGray)(resolvedPrimary), error: error || (0, colors_1.createColor)(DEFAULT_ERROR), warning: warning || (0, colors_1.createColor)(DEFAULT_WARNING), success: success || (0, colors_1.createColor)(DEFAULT_SUCCESS), additional: additional.map(convertToColor) }, other);
}
function getThemeColors({ accent, stroke, icon, background, backgroundHover, backgroundActive, }, colors) {
    const bg = (0, colors_1.createColor)(background !== null && background !== void 0 ? background : 'white');
    return {
        accent: accent !== null && accent !== void 0 ? accent : colors.primary,
        stroke: stroke !== null && stroke !== void 0 ? stroke : bg.getContrasting(colors.gray, 2),
        icon: icon !== null && icon !== void 0 ? icon : bg.getContrasting(colors.gray, 3),
        background: background !== null && background !== void 0 ? background : bg,
        backgroundHover: backgroundHover !== null && backgroundHover !== void 0 ? backgroundHover : bg,
        backgroundActive: backgroundActive !== null && backgroundActive !== void 0 ? backgroundActive : bg,
    };
}
function getButtonStyles({ colors }, _a = {}) {
    var { secondary, danger, icon, css: style } = _a, buttons = __rest(_a, ["secondary", "danger", "icon", "css"]);
    return Object.assign({ css: (0, styled_1.css) `
      background-color: ${colors.primary};
      color: ${colors.primary.getContrasting()};
      ${style}
    `, secondary: (0, styled_1.css) `
      background-color: ${colors.secondary};
      color: ${colors.secondary.getContrasting()};
      ${secondary}
    `, danger: (0, styled_1.css) `
      background-color: ${colors.error};
      color: ${colors.error.getContrasting()};
      ${danger}
    `, icon: (0, styled_1.css) `
      background-color: ${colors.primary};
      color: ${colors.primary.getContrasting()};
      ${icon}
    ` }, buttons);
}
function getTypographyStyles({ background, colors }, _a = {}) {
    var _b;
    var { css: baseCss } = _a, customTexts = __rest(_a, ["css"]);
    const typography = Object.assign({ css: (0, styled_1.css) `
      color: ${(0, colors_1.createColor)(background).getContrasting(colors.gray)};
      ${baseCss}
    ` }, (0, collections_1.map)((styles) => (isStyle(styles) ? { css: styles } : styles), customTexts));
    const _c = (_b = typography.note) !== null && _b !== void 0 ? _b : {}, { css: noteCss } = _c, noteVariants = __rest(_c, ["css"]);
    typography.note = Object.assign({ css: (0, styled_1.css) `
      color: ${(0, colors_1.createColor)(background).getContrasting(colors.gray, 2)};
      display: block;
      ${noteCss};
    ` }, noteVariants);
    return typography;
}
function isStyle(styles) {
    return typeof styles === 'function';
}
function getThemeContext(name, theme) {
    if (name === 'default') {
        return theme;
    }
    const context = theme._context[name] || {};
    const baseColor = /^additional\.\d+$/u.test(name)
        ? theme.colors.additional[Number.parseInt(name.split('.')[1])]
        : theme.colors[name];
    if (baseColor) {
        context.background = context.background || baseColor;
    }
    return contextProxy(context, theme);
}
exports.getThemeContext = getThemeContext;
function contextProxy(ctx, mirror, path = [], colors) {
    return new Proxy(ctx, {
        get: (obj, key) => {
            const prop = obj[key];
            const mirrorProp = mirror[key.toString()];
            if (!prop) {
                return mirrorProp;
            }
            const proxy = mirrorProp &&
                !(0, colors_1.isColor)(mirrorProp) &&
                !isStyle(prop) &&
                typeof mirrorProp === 'object';
            if (proxy) {
                return contextProxy(prop, mirrorProp, [...path, key], colors !== null && colors !== void 0 ? colors : (0, colors_1.isColor)(mirrorProp.primary));
            }
            return isStyle(mirrorProp === null || mirrorProp === void 0 ? void 0 : mirrorProp.css)
                ? contextProxy({ css: prop }, mirrorProp, [...path, key])
                : proxiedThemeProp(prop, mirrorProp, obj);
        },
    });
}
function proxiedThemeProp(prop, mirrorProp, from) {
    return isStyle(mirrorProp)
        ? (0, styled_1.css)(mirrorProp, prop)
        : typeof prop === 'function'
            ? (0, utils_1.has)(prop, 'prototype')
                ? prop.bind(from)
                : prop
            : (0, colors_1.isColor)(mirrorProp)
                ? (0, colors_1.createColor)(prop, Object.assign(Object.assign({}, mirrorProp.shades), ((0, colors_1.isColor)(prop) ? prop.shades : {})))
                : prop;
}
exports.DEFAULT_STYLES = {
    flexCenter: (0, styled_1.css) `
    display: flex;
    align-items: center;
    justify-content: center;
  `,
    truncate: (0, styled_1.css) `
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
    overlay: (0, styled_1.css) `
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  `,
    fadeIn: (0, styled_1.css) `
    animation: ${(0, css_1.keyframes) `
      from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
    `} 1s ease both;
  `,
};
function addDefaultStyles(theme) {
    (0, collections_1.keys)(exports.DEFAULT_STYLES).forEach((style) => {
        if (!(0, utils_1.has)(theme, style)) {
            (0, utils_1.set)(theme, style, exports.DEFAULT_STYLES[style]);
        }
    });
}
